import React, {useMemo} from "react";
import {FilterableTable} from "./FilterableTable";
import {Spinner, Text} from "@nike/eds";
import {PayloadView} from "../shared/PayloadView";
import {mapDuration} from "../shared/DurationMapper";
import DateTimeFormat from "../shared/DateTimeFormat";
import useSWR from "swr";

const FetchingData = () => (
    <div style={{margin: "auto", width: "1%"}}>
        <div>
            <Spinner size="large"/>
        </div>
        <div>
            <Text>Loading...</Text>
        </div>
    </div>
);

const mapLogLines = (logData) => {
    const lines = logData && logData.data ? logData.data.getRequestDetails.items : [];
    let previousTimestamp = null;
    //array is ordered on timestamp newest to oldest

    for (let item of lines.slice().reverse()) {
        if (previousTimestamp !== null && previousTimestamp !== undefined) {
            var utc1 = new Date(previousTimestamp);
            var utc2 = new Date(item.timestamp);
            item.duration = Math.floor(utc2.getTime() - utc1.getTime());
            previousTimestamp = item.timestamp;
        } else {
            previousTimestamp = item.timestamp;
            item.duration = 0;
        }
    }
    return lines;
}

function RequestDetailOverviewTab(props) {
    const structuredLogsService = props.structuredLogsService;

    const columns = useMemo(
        () => [
            {
                Header: "Timestamp",
                accessor: "timestamp",
                Cell: (props) => {
                    return <DateTimeFormat timestamp={props.value} />;
                },
            },
            {
                Header: "Duration",
                accessor: "duration",
                Cell: (props) => {
                    return <>{mapDuration(props.value)}</>;
                },
            },
            {
                Header: "Service",
                accessor: "componentName",
            },
            {
                Header: "Region",
                accessor: "region",
            },
            {
                Header: "Error description",
                accessor: "errorDescription",
            },
            {
                Header: "Message",
                accessor: "message",
            },
            {
                Header: "Payload",
                accessor: "payloadPath",
                Cell: (props) => {
                    return <PayloadView payloadRegion={props.row.original.payloadRegion}
                                 payloadBucket={props.row.original.payloadBucket}
                                 payloadPath={props.row.original.payloadPath}
                                 payloadVersion={props.row.original.payloadVersion}
                                 payloadSize={props.row.original.payloadSize}
                                 structuredLogsService={structuredLogsService}/>
                }
            }
        ],
        [structuredLogsService]
    );

    const fetcher = (requestIdentifier) =>  structuredLogsService.getRequestDetails(requestIdentifier.traceId, requestIdentifier.logType);
    const {data : logData, isLoading, error} = useSWR({traceId: props.traceId, logType: props.logType}, fetcher, {
        refreshInterval: 15
    });
    if (error) {
        console.log(logData, isLoading, error);
    }

    const data = mapLogLines(logData);

    return isLoading ? (
        <FetchingData/>
    ) : (
        <div>
            <FilterableTable data={data} columns={columns} loading={isLoading}/>
        </div>
    );
}

export {RequestDetailOverviewTab};
